import { BaseModel } from "./base.model";

export class SelectPromoVoucherListItem {

    //#region Fields

    couponName: string;
    couponFor: string;
    couponOn: string;
    couponGenerationType?: string;
    couponLimitType?: string;
    prefix?: string;
    startNumber?: string;
    endNumber?: string;
    totalCoupons?: string;
    isActive?: boolean;
    allowPromoDiscount?: boolean;
    isForAll?: boolean;
    preGST?: boolean;
    id?: string;

    //#endregion

    //#region Constructor

    constructor(id: string = '', couponName: string = '', couponOn: string = '') {
        this.id = id;
        this.couponName = couponName;
        this.couponOn = couponOn;
    }

    //#endregion

    //#region Methods

    static getDefaultSelectItem(): SelectPromoVoucherListItem {

        let languageId = 1;
        const languageTextMap: { [key: number]: { text: string, value: string } } = {
            1: { text: "Select All", value: "0" },
            2: { text: "Selecteer alle", value: "0" },
        };
        const defaultLanguageText = languageTextMap[languageId] || { text: "Default text", value: "0" };
        let itemObject = new SelectPromoVoucherListItem();
        itemObject.couponName = defaultLanguageText.text;
        itemObject.id = defaultLanguageText.value;
        return itemObject;
    }

    //#endregion

}
